export default "__VITE_ASSET__BaQJDzMb__"